export default __webpack_public_path__ + "static/media/Star.e58a336d.svg";